import { useState, useEffect, useMemo, useRef } from 'react'
import styled from 'styled-components'
import SVG, { Props as SVGProps } from 'react-inlinesvg'
import { device } from '../breakpoints'
// @ts-ignore
import smoothscroll from 'smoothscroll-polyfill'

smoothscroll.polyfill()

const categoriesIcons: {
  [key: string]: string
} = {
  'Troubles neurologiques': 'brain',
  Poitrine: 'lung',
  Poumons: 'lung',
  Ventre: 'intestine',
  Membres: 'muscle',
  Peau: 'skin',
}

const Menu = ({
  elements,
  active,
  handleClick,
  age,
  lang,
}: {
  elements: any
  active: any
  handleClick: (elementId: number) => void
  age: 'adults' | 'children'
  lang: 'fr' | 'de' | undefined
}) => {
  const container = useRef<HTMLDivElement>(null)
  const isMobile = window.innerWidth < 768

  const handleActive = (element: any) => {
    if (container.current && element) {
      // const targetPosition = isMobile
      //   ? element.getBoundingClientRect().left + container.current.scrollLeft
      //   : element.getBoundingClientRect().top + container.current.scrollTop

      const targetPosition = isMobile
        ? element.getBoundingClientRect().left + container.current.scrollLeft
        : element.getBoundingClientRect().top -
          container.current.getBoundingClientRect().top +
          container.current.scrollTop

      // console.log('Element:', element.getBoundingClientRect().top)
      // console.log('Container:', container.current.getBoundingClientRect().top)
      // console.log('Container scroll:', container.current.scrollTop)
      // console.log(
      //   'Target:',
      //   element,
      //   element.getBoundingClientRect(),
      //   targetPosition
      // )

      container.current.scrollTo({
        top: !isMobile
          ? targetPosition -
            container.current.getBoundingClientRect().height / 2
          : 0,
        left: isMobile ? targetPosition - 150 : 0,
        behavior: 'smooth',
      })
    }
  }

  // Create a the groups of symptoms
  // const categories = useMemo(() => {
  //   const categories: { [key: string]: Symptom[] } = {}
  //   elements.forEach((element: any) => {
  //     if (!categories[element.category]) {
  //       categories[element.category] = []
  //     }
  //     categories[element.category].push(element)
  //   })
  //   return categories
  // }, [elements])

  // When a new element is active, scroll to it
  // useEffect(() => {
  //   if (container.current) {
  //     const targetElement = active ? elements.find((e:any) => e.name === active.name) : null

  //     if (targetElement != null) {
  //     container.current.scrollTo({
  //       top: !isMobile ? targetElement.order * 108 : 0,
  //       left: isMobile ? targetElement.order * 110 : 0,
  //       behavior: 'smooth',
  //     })
  //   }
  //   }
  // }, [active, elements, isMobile])

  return (
    <>
      <MenuWrapper>
        <MenuContainer ref={container}>
          <MenuGroupContainer>
            {elements.map((element: Symptom, i: number) => {
              return (
                <MenuElement
                  handleClick={(id) => {
                    handleClick(id)
                  }}
                  handleActive={(e) => {
                    handleActive(e)
                  }}
                  key={`menu-element-${i}`}
                  element={element}
                  active={active.name === element.name}
                  index={i}
                />
              )
            })}
            {/* {Object.keys(categories).map((category, ci) => (
            <MenuGroup
              key={`menu-group-${ci}`}
              active={active}
              group={categories[category]}
              name={category}
              open={active ? active.category === category : false}
              handleClick={(id) => {
                handleClick(id)
              }}
              handleActive={(element) => {
                if (container.current && element) {
                  const targetPosition = isMobile
                    ? element.getBoundingClientRect().left +
                      container.current.scrollLeft
                    : element.getBoundingClientRect().top +
                      container.current.scrollTop

                  container.current.scrollTo({
                    top: !isMobile ? targetPosition - 300 : 0,
                    left: isMobile ? targetPosition - 150 : 0,
                    behavior: 'smooth',
                  })
                }
              }}
            />
          ))} */}
          </MenuGroupContainer>
        </MenuContainer>
      </MenuWrapper>
      <Note>
        {age === 'adults' ? (
          lang === 'fr' ? (
            <>
              Part des personnes infectées par le Covid souffrant de ce symptôme
              7 à 9 mois plus tard
            </>
          ) : (
            <>
              Anteil der Covid-Infizierten, die 7 bis 9 Monate später an diesem
              Symptom leiden
            </>
          )
        ) : lang === 'fr' ? (
          <>
            Part des mineurs infectés par le Covid souffrant de ce symptôme 2 à
            12 mois plus tard
          </>
        ) : (
          <>
            Anteil der mit Covid infizierten Kinder, die 2 bis 12 Monate später
            an diesem Symptom leiden
          </>
        )}
      </Note>
    </>
  )
}

// const MenuGroup = ({
//   group,
//   active,
//   name,
//   open,
//   handleActive,
//   handleClick,
// }: {
//   group: any
//   active: any
//   name: string
//   open: boolean
//   handleActive: (element: HTMLDivElement | null) => void
//   handleClick: (id: number) => void
// }) => {
//   const isMobile = window.innerWidth < 768

//   return (
//     <MenuGroupContainer>
//       <MenuGroupElementContainer
//         active={false}
//         onClick={() => {
//           handleClick(group[0].order)
//         }}
//       >
//         <MenuText>
//           <MenuTextName>{name}</MenuTextName>
//           <MenuTextPct>{group.length} symptômes</MenuTextPct>
//         </MenuText>
//       </MenuGroupElementContainer>
//       {group.map((element: Symptom, i: number) => {
//         return (
//           <MenuElement
//             handleClick={(id) => {
//               handleClick(id)
//             }}
//             handleActive={(e) => {
//               handleActive(e)
//             }}
//             key={`menu-element-${i}`}
//             element={element}
//             active={active.name === element.name}
//             index={i}
//           />
//         )
//       })}
//     </MenuGroupContainer>
//   )
// }

const MenuGroupContainer = styled.div`
  display: flex;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    flex-direction: row;
    align-items: center;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    flex-direction: column;
    align-items: center;
  }
`

const MenuElement = ({
  element,
  active,
  index,
  handleActive,
  handleClick,
}: {
  element: any
  active: boolean
  index: number
  handleActive: (element: HTMLDivElement | null) => void
  handleClick: (elementId: number) => void
}) => {
  const [ref, setRef] = useState<HTMLDivElement | null>(null)

  // We need to tell the parent component what html element is active
  // so we can scroll to it
  useEffect(() => {
    active && handleActive(ref)
  }, [element, handleActive, active, ref])

  return (
    <MenuElementContainer
      ref={setRef}
      active={active}
      onClick={() => {
        handleClick(element.order)
        // const target = document.getElementById(`step-${element.order}`)
        // console.log(target?.getBoundingClientRect())
        // const targetPosition = target
        //   ? window.scrollY +
        //     target.getBoundingClientRect().top -
        //     (isMobile ? window.innerHeight * 0.6 : window.innerHeight * 0.35)
        //   : 0
        // window.scrollTo({
        //   top: targetPosition,
        //   behavior: 'smooth',
        // })
      }}
    >
      {/* <Picto>
        <StyledSVG
          src={require('./icons/' + element.icon + '.svg')}
          title='Menu'
          color='#202346'
        />
      </Picto> */}
      <MenuText>
        <MenuTextName>{element.name}</MenuTextName>
        <MenuTextPct active={active}>
          {(element.pct * 100).toFixed(1) !== '0.0' ? (element.pct * 100).toFixed(1) : '<0.5'}%
        </MenuTextPct>
      </MenuText>
    </MenuElementContainer>
  )
}

const StyledSVG = styled(SVG)<SVGProps>`
  width: 90%;
  height: auto;
  & path,
  line,
  circle,
  polyline {
    stroke: ${({ theme }) => theme.purpleDark} !important;
    stroke-width: 10px !important;
  }
`

const Note = styled.div`
  z-index: 250;
  left: 40px;
  font-size: 12px;
  line-height: 1.2;
  opacity: 0.5;
  font-family: var(--font-sans-serif);
  text-align: center;
  padding: 0 15px;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    position: relative;
    top: 0;
    width: auto;
    left: 0%;
    margin-top: 6px;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    position: absolute;
    top: 75%;
    width: 60%;
    left: calc(20% - 40px);
    margin-top: 0;
  }
`

const Picto = styled.div`
  height: 100%;
  align-items: stretch;
  display: flex;
  justify-content: center;
  align-items: center;
`

const MenuWrapper = styled.div`
  z-index: 100;
  -ms-overflow-style: none;
  scrollbar-width: none;
  overflow: hidden;
  display: flex;
  justify-content: center;
  -webkit-font-smoothing: antialiased;

  &::-webkit-scrollbar {
    display: none;
  }

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    right: auto;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    position: relative;

    &:before {
      display: none;
      pointer-events: none;
      z-index: 200;
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      background: linear-gradient(
        -90deg,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 1) 69%
      );
      width: 50px;
      height: 100%;
    }

    &:after {
      pointer-events: none;
      z-index: 200;
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      background: linear-gradient(
        90deg,
        ${({theme}) => theme.colorMode === 'light' ? 'rgba(122, 63, 119, 0)' : 'rgba(34, 34, 34, 0)'} 0%,
        ${({theme}) => theme.colorMode === 'light' ? 'rgba(122, 63, 119, 1)' : 'rgba(34, 34, 34, 1)'} 100%
      );
      width: 50px;
      height: 100%;
    }
  }

  @media ${device.tablet}, @media ${device.laptop} {
    right: 0;
    left: auto;
    top: 50%;
    width: 100%;
    height: 50vh;
    position: relative;

    &:before {
      display: block;
      z-index: 200;
      content: '';
      position: absolute;
      top: 0;
      bottom: auto;
      left: 0;
      background: linear-gradient(
        0deg,
        ${({ theme }) =>
            theme.colorMode === 'dark'
              ? 'rgba(18, 18, 18, 0)'
              : 'rgba(255, 255, 255, 0)'}
          0%,
        ${({ theme }) =>
            theme.colorMode === 'dark'
              ? 'rgba(18, 18, 18, 1)'
              : 'rgba(255, 255, 255, 1)'}
          69%
      );
      width: 100%;
      height: 60px;
    }

    &:after {
      z-index: 200;
      content: '';
      position: absolute;
      top: auto;
      bottom: 0;
      left: 0;
      background: linear-gradient(
        180deg,
        ${({ theme }) =>
            theme.colorMode === 'dark'
              ? 'rgba(18, 18, 18, 0)'
              : 'rgba(255, 255, 255, 0)'}
          0%,
        ${({ theme }) =>
            theme.colorMode === 'dark'
              ? 'rgba(18, 18, 18, 1)'
              : 'rgba(255, 255, 255, 1)'}
          69%
      );
      width: 100%;
      height: 60px;
    }
  }
`

const MenuContainer = styled.div`
  z-index: 100;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    width: 100%;
    overflow-x: scroll;
    overflow-y: hidden;
    display: flex;
    align-items: center;
    background: ${({ theme }) => theme.colorMode === 'light' ? theme.purpleDark : '#222222'};
    padding: 10px 0px;
    height: auto;
    box-shadow: inset 0 7px 9px -7px rgba(0, 0, 0, 0.3);

    &:before {
      content: '';
      height: 100%;
      display: block;
      width: 10px;
      flex: 0 0 auto;
    }

    &:after {
      content: '';
      height: 100%;
      display: block;
      width: 100px;
      flex: 0 0 auto;
    }
  }

  @media ${device.tablet}, @media ${device.laptop} {
    width: 300px;
    overflow-x: hidden;
    overflow-y: scroll;
    display: block;
    align-items: auto;
    background: transparent;
    padding: 0;
    height: 100%;
    box-shadow: none;

    &:before {
      content: '';
      height: 100px;
      display: block;
      width: 100%;
    }

    &:after {
      content: '';
      height: 100px;
      display: block;
      width: 100%;
    }
  }
`

const MenuText = styled.div`
  position: relative;
  min-width: 100px;
  padding: 10px 20px;
`

const MenuTextName = styled.div`
  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    font-weight: 800;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    font-weight: 400;
  }
`

const MenuTextPct = styled.div<{
  active: boolean
}>`
  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    color: ${({ theme, active }) => (active ? theme.colorMode === 'dark' ? '#ffffff66' : theme.purpleMain : '#ffffff66')};
  }

  @media ${device.tablet}, @media ${device.laptop} {
    color: ${({ theme, active }) => (active ? '#ffffff66' : theme.purpleMain)};
  }
`

const MenuElementContainer = styled.div<{
  active: boolean
}>`
  position: relative;
  border-radius: 0;
  transition: transform ease-in 100ms;
  line-height: 1.2;
  box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.025),
    0px 0px 12px rgba(0, 0, 0, 0.025);
  align-items: center;
  cursor: pointer;
  margin: 7px;
  overflow: hidden;

  border-color: ${({ active }) => (active ? '#202346' : '#202346')};

  // border-style: solid;
  // border-width: ${({ active }) => (active ? '2px' : '2px')};

  &:hover {
    transform: translateX(-2px);
  }

  ${StyledSVG} {
    path,
    line,
    circle,
    polyline {
      stroke: ${({ active, theme }) =>
        active ? '#ffffff' : 'var(--text-color)'} !important;
    }
  }

  &:hover {
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);

    ${MenuText} {
      // display: block;
    }

    ${StyledSVG} {
      path,
      circle,
      line,
      polyline {
        // stroke: #ffffffef !important;
      }
    }
  }

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    font-family: var(--font-sans-serif);
    border-radius: 60px;
    font-size: 0.85em;
    margin-left: 10px;
    text-align: left;
    white-space: nowrap;
    color: ${({ active }) => (active ? 'var(--text-color)' : '#ffffff')};
    background-color: ${({ active, theme }) =>
      active
        ? theme.colorMode === 'dark'
          ? theme.purpleMain
          : '#ffffff'
        : theme.colorMode === 'dark' ? '#000000' : '#653463'};

    &:after {
      background-color: transparent !important;
    }

    ${StyledSVG} {
      path,
      circle,
      line,
      polyline {
        stroke-width: 16px !important;
        stroke: ${({ theme }) => 'var(--text-color)'} !important;
      }
    }
  }

  @media ${device.tablet}, @media ${device.laptop} {
    font-family: var(--font-source);
    border-radius: 60px;
    font-size: 1.2em;
    margin-left: 20px;
    border-width: 0px;
    text-align: center;
    white-space: break-spaces;
    color: ${({ active }) => (active ? '#ffffff' : 'var(--text-color)')};
    background-color: ${({ active, theme }) =>
      active
        ? theme.purpleDark
        : theme.colorMode === 'dark'
        ? '#232323'
        : '#ffffff'};
  }
`

const MenuGroupElementContainer = styled(MenuElementContainer)`
  padding-left: 0;
  display: none;

  &:after {
    display: none;
  }

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    font-size: 0.85em;
    grid-template-columns: 50px 1fr;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    font-size: 1em;
    grid-template-columns: 70px 1fr;
  }
`

const MenuGroupIconContainer = styled.div`
  background: #202346;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2em;
  height: 100%;
  border-radius: 20px 0 0 20px;

  ${StyledSVG} {
    path,
    line,
    circle,
    polyline {
      stroke: #ffffff !important;
    }
  }

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
  }

  @media ${device.tablet}, @media ${device.laptop} {
  }
`

const MenuGroupIcon = styled.div`
  flex: 1;
  padding: 10px;
`

export default Menu
